export enum LegTypes {
  fixed = 1,
  float = 2,
  cap = 3,
  floor = 4,
  inflation = 5,
  forward = 6,
  scheduledPayments = 7,
  compoundingFixed = 8,
  payGo = 9,
  windowedForward = 10,
  upfrontPremium = 11,
  commodityFixed = 12,
  commodityFloat = 13,
  commodityCall = 15,
  commodityPut = 16,
}
